var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title:
              _vm.paramsData.id !== ""
                ? _vm.$t("modifyMergeServerPreview")
                : _vm.$t("addMergeServerPreview"),
            visible: _vm.dialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "time",
                    rules: _vm.rules.time,
                    label: _vm.$t("specifyTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      "popper-class": "no-at-theMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    on: { change: _vm.handleTimeChange },
                    model: {
                      value: _vm.paramsData.time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "time", $$v)
                      },
                      expression: "paramsData.time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "areaId",
                    label: _vm.$t("mergeServerListLabel")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.handleAreaChange },
                      model: {
                        value: _vm.paramsData.areaId,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "areaId", $$v)
                        },
                        expression: "paramsData.areaId"
                      }
                    },
                    _vm._l(_vm.mergeServerList, function(item) {
                      return _c("el-option", {
                        key: item.master_id,
                        attrs: {
                          label: _vm.$t("regionLabelWithParam", {
                            region: item.master_id
                          }),
                          value: item.master_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.areaId !== "" && _vm.currentRangeList.length > 0
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        label: _vm.$t("mergeServerScope"),
                        prop: "merge_server_range"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "flex-1",
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: _vm.$t("pleaseSelectMergeServerScope")
                          },
                          on: { change: _vm.getRange },
                          model: {
                            value: _vm.paramsData.merge_server_range,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.paramsData,
                                "merge_server_range",
                                $$v
                              )
                            },
                            expression: "paramsData.merge_server_range"
                          }
                        },
                        _vm._l(_vm.currentRangeList, function(range, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: {
                              label: _vm.formatRangeLabel(range),
                              value: _vm.formatRangeLabel(range)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.merge_server_range
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        label: _vm.$t("serverListLabel"),
                        prop: "server_range"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "flex-1",
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            filterable: "",
                            placeholder: _vm.$t("pleaseChoose")
                          },
                          on: { change: _vm.handleServerChange },
                          model: {
                            value: _vm.paramsData.server_range,
                            callback: function($$v) {
                              _vm.$set(_vm.paramsData, "server_range", $$v)
                            },
                            expression: "paramsData.server_range"
                          }
                        },
                        _vm._l(_vm.serverRangList, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "merge_time",
                    rules: _vm.rules.merge_time,
                    label: _vm.$t("mergeServerTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      "popper-class": "no-at-theMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    model: {
                      value: _vm.paramsData.merge_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "merge_time", $$v)
                      },
                      expression: "paramsData.merge_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "prediction_time",
                    rules: _vm.rules.prediction_time,
                    label: _vm.$t("previewStartTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      "popper-class": "no-at-theMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    model: {
                      value: _vm.paramsData.prediction_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "prediction_time", $$v)
                      },
                      expression: "paramsData.prediction_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "end_merge_time",
                    rules: _vm.rules.end_merge_time,
                    label: _vm.$t("mergeServerEndTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      "popper-class": "no-at-theMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    model: {
                      value: _vm.paramsData.end_merge_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "end_merge_time", $$v)
                      },
                      expression: "paramsData.end_merge_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    label: _vm.$t("isEnableMailNotify"),
                    prop: "mail_notify",
                    rules: _vm.rules.mail_notify
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.paramsData.mail_notify,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "mail_notify", $$v)
                        },
                        expression: "paramsData.mail_notify"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("yes")))
                      ]),
                      _c("el-radio", { attrs: { label: 0, border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("no")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }